// OR-6018: `ConceptGroupOption` was promoted to the shared
// @verantos-dev/ui-concept-group-editor lib so the concept-group picker / row
// primitives can be reused by the Research Assistant intent checkpoint. It's
// re-exported here so the many in-feature imports of `ConceptGroupOption` stay
// unchanged.
import type { ConceptGroupOption } from '@verantos-dev/ui-concept-group-editor';

export type { ConceptGroupOption } from '@verantos-dev/ui-concept-group-editor';

/** Maps Redux concept groups to the shape expected by AnalyticalVariableCard. */
export function toConceptGroupOptions(
  conceptGroups:
    | Array<{ conceptGroupId: string; conceptGroupName: string; owner?: string; domains?: string }>
    | undefined
): ConceptGroupOption[] {
  return (
    conceptGroups?.map((cg) => ({
      conceptGroupId: cg.conceptGroupId,
      conceptGroupName: cg.conceptGroupName,
      owner: cg.owner,
      domains: cg.domains,
    })) ?? []
  );
}
